import { render, staticRenderFns } from "./SettingSpeFee.vue?vue&type=template&id=0656ff4e"
import script from "./SettingSpeFee.vue?vue&type=script&lang=js"
export * from "./SettingSpeFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports